
















































































































import Vue from "vue";
import { BvTableCtxObject } from "bootstrap-vue";
import { formatDate } from "@/lib/utils";
import { AxiosResponse } from "axios";

export default Vue.extend({
  name: "ProcessLogs",
  props: {
    run_id: String,
  },
  data() {
    return {
      fields: [
        { key: "timestamp", label: "Time", formatter: formatDate },
        { key: "location", label: "Where" },
        "level",
        { key: "message", tdClass: "text-left" },
      ],
      filter: {
        message: undefined,
        logLevel: 2,
      },
      filterPanel: false,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      perPageOptions: [10, 20, 50, 100, 1000],
      logFlags: ["DEBUG", "VERBOSE", "INFO", "SHOUT", "WARNING", "ERROR"],
      logFlagOptions: [
        { value: 0, text: "DEBUG" },
        { value: 1, text: "VERBOSE" },
        { value: 2, text: "INFO" },
        { value: 3, text: "SHOUT" },
        { value: 4, text: "WARNING" },
        { value: 5, text: "ERROR" },
      ],
    };
  },
  created() {
    this.countRows();
  },
  watch: {
    "filter.message": function () {
      this.countRows();
    },
    "filter.logLevel": function () {
      this.countRows();
    },
  },
  methods: {
    getLogFlags(): undefined | Array<string> {
      if (this.filter.logLevel == undefined) {
        return undefined;
      }
      let flags = [];
      for (var i in this.logFlagOptions) {
        if (this.logFlagOptions[i].value >= this.filter.logLevel) {
          flags.push(this.logFlagOptions[i].text);
        }
      }
      return flags;
    },
    loadData(ctx: BvTableCtxObject, callback: Function): void {
      this.$store.state.api_client
        .get("/live/events/" + this.run_id + "/logs", {
          params: {
            skip: (ctx.currentPage - 1) * ctx.perPage,
            limit: ctx.perPage,
            // @ts-ignore
            filter: ctx.filter.message,
            flags: this.getLogFlags(),
          },
        })
        .then((response: AxiosResponse) => {
          callback(response.data.logs);
        })
        .catch((error: Error) => {
          console.log(error);
          callback([]);
        });
    },
    countRows(): void {
      this.$store.state.api_client
        .get("/live/events/" + this.run_id + "/logs/count", {
          params: { filter: this.filter.message, flags: this.getLogFlags() },
        })
        .then((response: AxiosResponse) => {
          this.totalRows = response.data.length;
        })
        .catch((error: Error) => {
          console.log(error);
        });
    },
    forceDownload() {
      this.$store.state.api_client
        .get("/live/events/" + this.run_id + "/logs", { responseType: "blob" })
        .then((response: AxiosResponse) => {
          const blob = new Blob([response.data], { type: "application/json" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${this.run_id}.json`;
          link.click();
          URL.revokeObjectURL(link.href);
        });
    },
  },
});
